import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import api from '../../services/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';

export default function ApprovalSteps() {
  const [hierarchies, setHierarchies] = useState([]);
  const [selectedHierarchy, setSelectedHierarchy] = useState(null);
  const [steps, setSteps] = useState([]);
  const [users, setUsers] = useState([]);
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [newStep, setNewStep] = useState({ level: 1, user_id: null, leave_type_id: null });
  const [newHierarchyName, setNewHierarchyName] = useState('');

  useEffect(() => {
    fetchHierarchies();
    fetchUsers();
    fetchLeaveTypes();
  }, []);

  const fetchHierarchies = async () => {
    const res = await api.get('/approval-hierarchies');
    setHierarchies(res.data);
  };

  const fetchUsers = async () => {
    const res = await api.get('/users');
    setUsers(res.data);
  };

  const fetchLeaveTypes = async () => {
    const res = await api.get('/leave-requests/leave-types');
    setLeaveTypes(res.data);
  };

  const fetchSteps = async (hierarchyId) => {
    const res = await api.get(`/approval-steps?hierarchy_id=${hierarchyId}`);
    setSteps(res.data);
  };

  const openModal = async (hierarchy) => {
    setSelectedHierarchy(hierarchy);
    await fetchSteps(hierarchy.id);
    setModalVisible(true);
  };

  const handleStepChange = (field, value) => {
    setNewStep(prev => ({ ...prev, [field]: value }));
  };

  const handleAddStep = async () => {
    await api.post('/approval-steps', {
      hierarchy_id: selectedHierarchy.id,
      level: newStep.level,
      user_id: newStep.user_id,
      department_id: null,
      position_id: null,
      leave_type_id: newStep.leave_type_id
    });

    await fetchSteps(selectedHierarchy.id);
    setNewStep({ level: 1, user_id: null, leave_type_id: null });
  };

  const handleDeleteStep = async (stepId) => {
    await api.delete(`/approval-steps/${stepId}`);
    await fetchSteps(selectedHierarchy.id);
  };

  const handleDeleteHierarchy = async (id) => {
    await api.delete(`/approval-hierarchies/${id}`);
    await fetchHierarchies();
  };

  const handleAddHierarchy = async () => {
    if (!newHierarchyName.trim()) return;
    await api.post('/approval-hierarchies', { name: newHierarchyName });
    setNewHierarchyName('');
    await fetchHierarchies();
  };

  const getUserName = (userId) => {
    const user = users.find(u => u.id === userId);
    return user ? `${user.first_name} ${user.last_name}` : '-';
  };

  return (
    <div className="p-4">
      <h2>İzin Onay Adımları</h2>

      {/* Yeni Hiyerarşi Ekleme */}
      <div className="flex gap-2 mb-4">
        <InputText
          value={newHierarchyName}
          onChange={(e) => setNewHierarchyName(e.target.value)}
          placeholder="Yeni hiyerarşi adı"
        />
        <Button label="Ekle" icon="pi pi-plus" onClick={handleAddHierarchy} />
      </div>

      {/* Hiyerarşi Kartları */}
      <div className="grid">
        {hierarchies.map(h => (
          <div className="col-12 md:col-6 lg:col-4" key={h.id}>
            <div className="p-card p-3 shadow-2 border-round surface-card">
              <h4>{h.name}</h4>
              <div className="flex justify-content-between mt-2">
                <Button
                  label="Detayları Gör"
                  icon="pi pi-eye"
                  className="p-button-sm"
                  onClick={() => openModal(h)}
                />
                <Button
                  icon="pi pi-trash"
                  className="p-button-sm p-button-danger"
                  onClick={() => handleDeleteHierarchy(h.id)}
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      <Dialog
        header={selectedHierarchy?.name + ' - Onay Adımları'}
        visible={modalVisible}
        style={{ width: '60vw' }}
        modal
        onHide={() => setModalVisible(false)}
      >
        {/* Adım Tablosu */}
        <DataTable value={steps} responsiveLayout="scroll">
          <Column field="level" header="Level" />
          <Column header="Kullanıcı" body={(row) => getUserName(row.user_id)} />
          <Column field="leave_type.name" header="İzin Tipi" />
          <Column
            header="Sil"
            body={(row) => (
              <Button
                icon="pi pi-trash"
                className="p-button-text p-button-danger"
                onClick={() => handleDeleteStep(row.id)}
              />
            )}
          />
        </DataTable>

        {/* Yeni Adım Ekleme */}
        <div className="p-fluid grid mt-4">
          <div className="col-12">
            <h4>Yeni Adım Ekle</h4>
          </div>
          <div className="col-3">
            <label>Level</label>
            <InputNumber
              value={newStep.level}
              onValueChange={(e) => handleStepChange('level', e.value)}
            />
          </div>
          <div className="col-5">
            <label>Kullanıcı</label>
            <Dropdown
              value={newStep.user_id}
              options={users.map(u => ({
                label: `${u.first_name} ${u.last_name}`,
                value: u.id
              }))}
              onChange={(e) => handleStepChange('user_id', e.value)}
              placeholder="Kullanıcı seç"
            />
          </div>
          <div className="col-4">
            <label>İzin Tipi</label>
            <Dropdown
              value={newStep.leave_type_id}
              options={leaveTypes.map(t => ({ label: t.name, value: t.id }))}
              onChange={(e) => handleStepChange('leave_type_id', e.value)}
              placeholder="İzin Tipi"
            />
          </div>
          <div className="col-12 flex justify-content-end mt-3">
            <Button
              label="Adım Ekle"
              icon="pi pi-plus"
              onClick={handleAddStep}
              disabled={!newStep.user_id || !newStep.leave_type_id}
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
}
